import {
  NetworkWifi,
  NetworkWifi1Bar,
  NetworkWifi2Bar,
  NetworkWifi3Bar,
  SignalWifi0Bar,
  SignalWifi4Bar,
} from "@mui/icons-material";
import React from "react";

const WifiSignal = React.forwardRef((props, ref) => {
  const { signal = 1 } = props;

  const getComponent = () => {
    switch (signal) {
      case 0:
        return SignalWifi0Bar;
      case 1:
        return NetworkWifi1Bar;
      case 2:
        return NetworkWifi2Bar;
      case 3:
        return NetworkWifi3Bar;
      case 4:
        return NetworkWifi;

      default:
        return SignalWifi4Bar;
    }
  };
  const Component = getComponent();
  return <Component {...props} ref={ref} className="wizard-status-child" />;
});

export default WifiSignal;
